import Vue from 'vue';
import I18n from 'vue-i18n';
Vue.use(I18n);

export default new I18n({
    locale: "zh-CN",
    fallbackLocale: "en-US",
    // silentFallbackWarn: true,
    messages: {
        "zh-CN": require("./lang/zh-CN"),
        "zh-HK": require("./lang/zh-HK"),
        "en-US": require("./lang/en-US"),
        "ar-AE": require("./lang/ar-AE"),
        "pl-PL": require("./lang/pl-PL"),
        "fa": require("./lang/fa"),
        "da-DK": require("./lang/da-DK"),
        "de-AT": require("./lang/de-AT"),
        "ru-RU": require("./lang/ru-RU"),
        "fr-FR": require("./lang/fr-FR"),
        "nl-NL": require("./lang/nl-NL"),
        "cs-CZ": require("./lang/cs-CZ"),
        "ro-RO": require("./lang/ro-RO"),
        "pt-BR": require("./lang/pt-BR"),
        "ja-JP": require("./lang/ja-JP"),
        "th-TH": require("./lang/th-TH"),
        "tr-TR": require("./lang/tr-TR"),
        "es-ES": require("./lang/es-ES"),
        "el-GR": require("./lang/el-GR"),
        "it-IT": require("./lang/it-IT"),
        "vi": require("./lang/vi"),
        "hi-IN": require("./lang/hi-IN"),
        "ko-KR": require("./lang/ko-KR"),
        "id-ID": require("./lang/id-ID"),
        "ms-MY": require("./lang/ms-MY"),
        "bn": require("./lang/bn"),   // 孟加拉语
        "he": require("./lang/he"),   // 希伯来语
        "uk": require("./lang/uk"),   // 乌克兰语
        "km": require("./lang/km"),   // 高棉语
        "sk": require("./lang/sk"),   // 斯洛伐克语
        "hu": require("./lang/hu"),   // 匈牙利语
        "sl": require("./lang/sl"),   // 斯洛文尼亚语
        "bg": require("./lang/bg"),   // 保加利亚语
        "hr": require("./lang/hr")    // 克罗地亚语
    }
})